import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router";
import { getCompaniesAdapter } from "../../../adapters/transversal.adapter";
import useForm from "../../../hooks/useForm";
import {
  getCurrentStateByUser,
  getDiagnosticQuestions,
  postResponsesDiagnostic
} from "../../../services/mentoriaService";
import { getCompaniesSearch } from "../../../services/transversal.service";
import Loader from "../../../shared/src/components/atoms/loader/loader";
import UserPointsContext from "../../../shared/src/components/organisms/layout/contexts/user-points.context";
import { getPurposeByUser } from "../../../shared/src/services/user-info.service";
import getIconByPurpose from "../../../utils/getIconByPurpose";
import ProgressCircle from "../../atoms/progress-circle/ProgressCircle";
import Stepper from "../../atoms/stepper/stepper";
import StepperDropdown from "../../molecules/stepper-dropdown/StepperDropdown";
import QuestionWizard from "../question-wizard/questionWizard";
import "./diagnostico.scss";

const Diagnostico = () => {
  const [purposeIcon, setPurposeIcon] = useState<string | null>(null);
  const diagnosticProgressRef = useRef(0);
  const navigate = useNavigate();
  const { getPoints } = useContext(UserPointsContext);
  const {
    formData,
    headers,
    step,
    setStep,
    loading,
    formQuestions,
    parentRef,
    currentQuestionIdx,
    appContext,
    handleContinueResults,
    setData
  } = useForm({
    getQuestions: getDiagnosticQuestions,
    sendAnswers: postResponsesDiagnostic,
    onSaveAnswers: getPoints,
    onFinishRedirect: "/formulario-salud-educacion-financiera/resultado"
  });

  const validateUser = async () => {
    const resultsRes = await getCurrentStateByUser();

    if (!resultsRes.data.data.hasPurpose) {
      navigate("/");
      return;
    }
  };

  const customizedQuestions = (questions) => {
    if (!questions) return [];
    return questions.map((question) => {
      if (question.id === 31) {
        // custom for "Company you worked for?"
        let enrichedQuestion = { ...question };
        enrichedQuestion.onCustomChange = async (keyword: string) => {
          let searchValue = keyword.trim();
          let defaultOption = { id: Date.now(), name: searchValue };
          if (!searchValue || searchValue.length < 3) return [];
          try {
            let companies = await getCompaniesSearch(searchValue);
            let options = getCompaniesAdapter(companies.data.data);
            options.push(defaultOption);
            return options;
          } catch (error) {
            console.error("Error getting companies...");
            return [defaultOption];
          }
        };
        return enrichedQuestion;
      }

      // return same question
      return question;
    });
  };

  const memoizedQuestions = useMemo(
    () => customizedQuestions(formQuestions),
    [formQuestions]
  );

  const handleSetProgress = (progress: number) => {
    if (diagnosticProgressRef.current === progress) return;
    diagnosticProgressRef.current = progress;
  };

  const getPurpose = async () => {
		try {
		const purpose = await getPurposeByUser();
		setPurposeIcon(getIconByPurpose(purpose.data?.data?.id || 0));
		} catch (error) {
			setPurposeIcon(getIconByPurpose(0));
		}
	};

  useEffect(() => {
    validateUser();
  }, []);

  useEffect(() => {
    getPurpose();
  }, []);

  if (loading || appContext.loading || !formQuestions) {
    return <Loader />;
  }

  return (
    <div className="o-mentoriaDiagnostico-container">
      <>
        <div className="o-mentoriaDiagnostico-container__progress-header-container">
          <div style={{flex: 1}}>
            <StepperDropdown
              steps={headers}
              current={headers.findIndex((item) => item.value == step)}
              size={18}
            />
          </div>
          <div>
            <ProgressCircle progress={diagnosticProgressRef.current} icon={purposeIcon} size={10} />
          </div>
        </div>
        <Stepper steps={headers} currentStep={step} ref={parentRef} />
        <QuestionWizard
          questions={memoizedQuestions}
          formData={formData}
          setData={setData}
          onMoveAfterFallback={handleContinueResults}
          onMovePreviousFallback={() => {}}
          setHeaderStep={setStep}
          parentRef={parentRef}
          counter={currentQuestionIdx}
          customProgressBar={(progress: number) => {
            handleSetProgress(progress);
            return <ProgressCircle progress={progress} icon={purposeIcon} />
          }}
        />
      </>
    </div>
  );
};

export default Diagnostico;
